<template>
    <div>
        <div style="margin-bottom: 28px; display: flex; flex-direction: row; justify-content: space-between; align-items: center;" class="flex-wrap">
            <div class="d-flex">
                <router-link :to="'/qr-code/dealer-stock'">
                    <svg class="mr-1" width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.22936 8.47377L5.00069 12.2451L5.94336 11.3024L2.64336 8.00243L5.94336 4.70243L5.00069 3.75977L1.22936 7.5311C1.10438 7.65612 1.03417 7.82566 1.03417 8.00243C1.03417 8.17921 1.10438 8.34875 1.22936 8.47377Z" fill="#4B4B4B"/>
                    </svg>
                </router-link>
                <h2 style="font-weight: 600; font-size: 18px; margin-bottom: 0;">
                    <router-link class="text-dark" :to="'/qr-code/dealer-stock'">Back</router-link> 
                    <span class="text-light-gray"> | Stock QR</span>
                </h2>
                <svg class="mx-1" width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.77064 8.47377L2.99931 12.2451L2.05664 11.3024L5.35664 8.00243L2.05664 4.70243L2.99931 3.75977L6.77064 7.5311C6.89562 7.65612 6.96583 7.82566 6.96583 8.00243C6.96583 8.17921 6.89562 8.34875 6.77064 8.47377Z" fill="#4B4B4B"/>
                </svg>
                <h2 style="font-weight: 600; font-size: 18px; margin-bottom: 0;">{{ kode_dealer }}</h2>
            </div>
        </div>
        <div class="bg-white rounded shadow-sm mb-3">
            <div class="d-flex flex-row flex-wrap align-items-center justify-content-between mb-3" style="padding: 20px">
                <h3 class="h5 font-weight-semibold">Detail Riwayat Stok QR Code</h3>
            </div>

            <div class="w-100 overflow-auto">
                <table class="table w-100 qtrust-table">
                    <thead>
                        <tr>
                            <th>Tanggal Edit</th>
                            <th>Edit Stok</th>
                            <th>Stok QR Lama</th>
                            <th>Jumlah Edit Stok QR</th>
                            <th>Stok QR Baru</th>
                            <th>Alasan</th>
                            <th>Nama Editor</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(dat, index) in data" :key="dat.created_at">
                            <td>{{ formatDate(dat.created_at) }}</td>
                            <td>{{ dat.type === 1 ? 'Penambahan' : 'Pengurangan' }}</td>
                            <td>{{ dat.qty_before }}</td>
                            <td :class="{'text-success': dat.type === 1, 'text-danger': dat.type !== 1}">
                                <div :class="bgClass(dat)">
                                    {{ displayQuantity(dat) }}
                                </div>
                            </td>
                            <td>{{ dat.qty_after }}</td>
                            <td>{{ dat.reason }}</td>
                            <td>{{ dat.name }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            kode_dealer: {
                type: String,
                required: true,
            },
        },
        data () {
            return {
                data : [],
            }
        },
        mounted() {
            console.log("Received kode_dealer:", this.kode_dealer); 
            this.fetchDealerHistory(this.kode_dealer);
        },
        methods : {
            async fetchDealerHistory(kode_dealer) {
                try {
                    const response = await this.$http.get(`/api/qrs/qr-stock-adjust-list`, {
                        params: { kode_dealer }
                    });

                    this.data = response.data.data;
                } catch (error) {
                    console.error("Error fetching dealer history:", error);
                }
            },

            formatDate(date) {
                const options = { 
                    year: 'numeric', 
                    month: 'short', 
                    day: '2-digit', 
                    hour: '2-digit', 
                    minute: '2-digit',
                    hour12: false 
                };
                
                const formattedDate = new Date(date).toLocaleString('en-GB', options);
                return formattedDate.replace(',', ' |');
            },
            

            displayQuantity(dat) {
        return dat.type === 1 ? `+ ${dat.qty}` : `- ${dat.qty}`;
            },
            bgClass(dat) {
            return dat.type === 1 ? 'bg-success-custom' : 'bg-danger-custom';
            }
        },
    }
</script>

<style scoped>
    .qtrust-table > thead > tr > th {
        text-align: left;
        border-top: 2px solid #F3F3F3;
        border-bottom: 2px solid #F3F3F3;
        padding: 8px 16px;
    }

    .qtrust-table > tbody > tr > td {
        text-align: left;
        padding: 8px 16px;
        border-bottom: 1px solid #F3F3F3;
    }

    .bg-danger-custom {
        display: inline-block;
        background-color: #FFEFEF; 
        min-width: 50px;
        padding: 3px; 
        max-width: 100%; 
        word-wrap: break-word;
        white-space: normal;
    }

    .bg-success-custom {
        display: inline-block;
        background-color: #F3FFEF; 
        min-width: 50px;
        padding: 3px; 
        max-width: 100%; 
        word-wrap: break-word; 
        white-space: normal;
    }

    .text-light-gray {
        color: #C1C1C1;
    }
</style>